/* ==========================================================================
   Tire Pressure Temperature Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-ptc]');
  if (!root) return;

  /* Gay-Lussac's law on absolute pressure and absolute temperature.
     Gauge pressure has to be converted to absolute first, which is the step
     the "1 psi per 10 degrees" rule of thumb quietly skips. */
  var ATM_PSI = 14.7;
  var F_TO_RANKINE = 459.67;

  /* TPMS warns at 25% below the placard pressure in the US. */
  var TPMS_WARN_FRACTION = 0.75;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function shift(psiGauge, fFrom, fTo) {
    var absFrom = psiGauge + ATM_PSI;
    var rFrom = fFrom + F_TO_RANKINE;
    var rTo   = fTo + F_TO_RANKINE;
    if (rFrom <= 0) return NaN;
    return (absFrom * (rTo / rFrom)) - ATM_PSI;
  }

  function compute(input) {
    if (!isFinite(input.psi) || input.psi <= 0) {
      return { ok: false, errors: ['Enter the pressure you set the tires to.'] };
    }
    if (!isFinite(input.t1) || !isFinite(input.t2)) {
      return { ok: false, errors: ['Enter both temperatures in Fahrenheit.'] };
    }

    var newPsi = shift(input.psi, input.t1, input.t2);
    var delta  = newPsi - input.psi;
    var degrees = input.t2 - input.t1;
    var perTen = degrees !== 0 ? (delta / degrees) * 10 : 0;

    var placard = isFinite(input.placard) && input.placard > 0 ? input.placard : input.psi;
    var warnAt = placard * TPMS_WARN_FRACTION;

    var status;
    if (newPsi <= warnAt) {
      status = { key: 'now', label: num(newPsi, 1) + ' psi',
                 note: 'Below the TPMS warning threshold of ' + num(warnAt, 1) + ' psi. The dashboard light will be on.' };
    } else if (newPsi < placard - 3) {
      status = { key: 'soon', label: num(newPsi, 1) + ' psi',
                 note: 'Under the placard pressure by ' + num(placard - newPsi, 1) + ' psi. Worth topping up.' };
    } else if (newPsi > placard + 5) {
      status = { key: 'monitor', label: num(newPsi, 1) + ' psi',
                 note: 'Over the placard pressure. Set pressures cold rather than bleeding them down warm.' };
    } else {
      status = { key: 'good', label: num(newPsi, 1) + ' psi',
                 note: 'Close enough to the placard pressure.' };
    }

    var rows = [
      { head: 'The change' },
      { label: 'Set at', value: num(input.psi, 1) + ' psi @ ' + num(input.t1, 0) + 'F' },
      { label: 'Now reads', value: num(newPsi, 1) + ' psi @ ' + num(input.t2, 0) + 'F' },
      { label: 'Difference', value: signed(delta, 1) + ' psi' },
      { label: 'Temperature change', value: signed(degrees, 0) + ' F' },
      { label: 'Rate', value: num(Math.abs(perTen), 2) + ' psi per 10F' },
      { head: 'Against the placard' },
      { label: 'Placard pressure', value: num(placard, 0) + ' psi' },
      { label: 'TPMS warns below', value: num(warnAt, 1) + ' psi' },
      { label: 'To restore placard', value: newPsi < placard
          ? 'Add ' + num(placard - newPsi, 1) + ' psi' : 'Nothing needed' }
    ];

    var warnings = [];
    if (input.t2 < input.t1 - 40) {
      warnings.push('That is a big overnight swing. Check pressures in the morning before driving, because rolling warms the tire and hides the problem.');
    }

    return {
      ok: true, errors: [], warnings: warnings, status: status,
      figures: [
        { label: 'Pressure at ' + num(input.t2, 0) + 'F', value: num(newPsi, 1) + ' psi',
          sub: signed(delta, 1) + ' psi from where you set it.' },
        { label: 'Rule of thumb', value: num(Math.abs(perTen), 2) + ' psi / 10F',
          sub: 'Close to the familiar 1 psi per 10 degrees.' }
      ],
      rows: rows
    };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "psi",
          "key": "p",
          "type": "number"
      },
      {
          "name": "t1",
          "key": "t1",
          "type": "number"
      },
      {
          "name": "t2",
          "key": "t2",
          "type": "number"
      },
      {
          "name": "placard",
          "key": "pl",
          "type": "number"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-ptc__figure">'
        + '<div class="pc-ptc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-ptc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-ptc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-ptc__row pc-ptc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-ptc__row">'
        + '<span class="pc-ptc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-ptc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_PTC = { compute: compute };
})();
